import { ComboboxControl } from '@/components/controls/combobox-control';
import { InputControl } from '@/components/controls/input-control';
import SelectControl from '@/components/controls/select-control';
import { Heading } from '@/components/heading/Heading';
import { Button } from '@/components/ui/button';
import { Form } from '@/components/ui/form';
import useMeasureStore from '@/features/loads/components/general/store/useMeasureStore';
import { cn } from '@/lib/utils';
import { CircleCheck } from 'lucide-react';
import { FC, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { useParties } from '../../hooks';
import { usePartyStore } from '../../store/usePartyStore';

export const PartiesAction: FC = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const { type, form, onSubmit, isLoading } = useParties();

  const { control } = form;

  const {
    cropTypes,
    clusters,
    generationTypes,
    industrialGrades,
    classList,
    cropGenerations,
    fetchClusters,
    storageTypes,
  } = usePartyStore();
  const { harvestType } = useMeasureStore();

  const generation = form.watch('generation');
  useEffect(() => {
    if (generation === 'TECHNICAL') {
      form.setValue('crop_generation_id', undefined);
    }
  }, [generation]);

  useEffect(() => {
    fetchClusters();
  }, []);

  return (
    <div className="flex flex-col py-8 px-10 w-full">
      <div className="flex-h-center-between mb-6">
        <Heading
          title={type === 'add' ? 'add.parties' : 'edit.parties'}
          back
          onBack={() => navigate(-1)}
        />
      </div>
      <Form {...form}>
        <form
          onSubmit={onSubmit}
          className={cn('flex flex-col items-end space-y-5')}
        >
          <div className="grid grid-cols-10 gap-4 w-full">
            <InputControl
              control={control}
              name="place_number"
              label={t('place.number')}
              placeholder={t('enter.party.number')}
              className="col-span-2"
            />
            <InputControl
              control={control}
              name="party_number"
              label={t('party.number')}
              placeholder={t('enter.party.number')}
              className="col-span-2"
            />
            <SelectControl
              name="cluster_id"
              label={t('claster')}
              options={clusters}
              control={control}
              placeholder={t('choose.data')}
              className="col-span-2"
            />
            <ComboboxControl
              name="crop_type_id"
              label={t('selection.type')}
              options={cropTypes}
              control={control}
              placeholder={t('choose.data')}
              className="col-span-2"
            />
            <SelectControl
              name="industrial_grade"
              label={t('industry.type')}
              options={industrialGrades}
              control={control}
              placeholder={t('choose.data')}
              className="col-span-2"
            />
            <SelectControl
              name="class"
              label={t('industrial.grade')}
              options={classList}
              control={control}
              placeholder={t('choose.data')}
              className="col-span-2"
            />
            <SelectControl
              name="generation"
              label={t('generation.type')}
              options={generationTypes}
              control={control}
              placeholder={t('choose.data')}
              className="col-span-2"
            />

            {generation !== 'TECHNICAL' && (
              <SelectControl
                name="crop_generation_id"
                label={t('generation')}
                options={cropGenerations}
                control={control}
                placeholder={t('choose.data')}
                className="col-span-2"
                disabled={!form.watch('generation')}
              />
            )}
            <SelectControl
              name="harvest_type"
              label={t('harvest.type')}
              options={harvestType}
              control={control}
              placeholder={t('choose.data')}
              className="col-span-2"
              disableSort
            />
            {type === 'add' && generation === 'SEED' && (
              <SelectControl
                name="storage_type"
                label="Saqlash turi"
                options={storageTypes}
                control={control}
                placeholder={t('choose.data')}
                className="col-span-2"
                disabled={!form.watch('generation')}
              />
            )}
            <InputControl
              control={control}
              name="capacity"
              label={t('capacity.kg')}
              placeholder={t('enter.capacity')}
              className="col-span-2"
            />
          </div>

          <Button type="submit" isLoading={isLoading}>
            <CircleCheck color="white" size="18" />
            {t('save')}
          </Button>
        </form>
      </Form>
    </div>
  );
};
